










import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class UtxoThreshold extends Vue {
    @Prop() threshold!: number
    @Prop() addresses!: string[]
}
